/*@ngInject*/
const NotificationGrowlController = function () {

    this.$onInit = function () {
        if (this.isLoadingBar) {
            this.clearTimer();
        }
    };

    this.onGrowlClick = function (event) {
        // prevent propagation to the onGrowlClick() function
        event.stopPropagation();
        event.preventDefault();

        if (!this.isLoadingBar) {
            // call the bound function to close the notification
            this.closeNotification();

            return false;
        }
    };

    this.getNotificationMessage = function () {
        return this.notification;
    };

    this.startDelay = function () {
        if (!this.isLoadingBar) {
            this.startTimer();
        }
    };

    this.resetDelay = function () {
        if (!this.isLoadingBar) {
            this.clearTimer();
        }
    };

    this.$onChanges = function (changes) {
        if (!_.isNil(changes.isLoadingBar)) {
            // If the notification growl changed to a non-loading bar, trigger the start of the delay
            if (changes.isLoadingBar.currentValue !== changes.isLoadingBar.previousValue && !this.isLoadingBar) {
                this.startDelay();
            }
        }
    };
};

angular.module('umCore')
    .controller('notificationGrowlController', NotificationGrowlController);
